// Fallback empty messages file
// Used when no messagesPath is provided in plugin options
export const messages = {}